export const responsiveSizesPage =
    '(min-width: 1280px) 800px, (min-width: 960px) 66vw, 100vw';

export const responsiveSizesLightbox =
    '(min-width: 1500px) 1280px, (min-width: 960px) 85vw, 100vw';
